/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-08T11:03:22.498
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getRentMaterialReceivingFormEditInit,
	getRentMaterialReceivingFormView
} from '@api/rentmanage/RentMaterialReceivingForm';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},

	actions: {
		getRentMaterialReceivingFormEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentMaterialReceivingFormEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentMaterialReceivingFormView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentMaterialReceivingFormView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
